/**
 * Handles description change for a specific file item.
 * Mutates the item directly — no notify needed, form controls own their own render.
 */
export default class OnDescriptionChangedHandler {

    /**
     * @param {object} state - shared upload state from UploadAttachmentHandler
     */
    constructor(state) {
        this._state = state;
    }

    /**
     * @param {{ index: number, value: string }} data
     */
    handle({ index, value }) {
        const item = this._state.files[index];
        if (!item) return;
        item.description = value;
    }
}
